<template>
  <div class="ev-login container">
    <h1>Flexapp Dashboard</h1>
    <div class="login-form">
      <b-field label="Gebruikersnaam">
        <b-input v-model="credentials.username"></b-input>
      </b-field>
      <b-field label="Wachtwoord">
        <b-input type="password" v-model="credentials.password">
        </b-input>
      </b-field>
      <a class="button is-info" @click="submit()">Inloggen</a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'login',

  data() {
    return {
      credentials: {
        username: '',
        password: '',
      },
      loggingIn: false,
      error: '',
    };
  },
  methods: {
    submit() {
      this.$auth.login({
        data: {
          username: this.credentials.username,
          password: this.credentials.password,
        },
        redirect: '/dashboard/buildings/all/all/all',
        fetchUser: true,
        rememberMe: true,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
h1 {
  font-weight: 900;
  font-size: 150%;
}

.ev-login {
  text-align: left;
  margin-top: 5em;
  margin-bottom: 5em;
}

.login-form {
  margin-top:2em;
}
</style>
